export const mergeConversationMessages = (backendMessages) => {
  let merged = [];
  let buffer = null;

  backendMessages.forEach((m) => {
    const isUser = m.role === "user";

    if (isUser) {
      if (buffer) {
        merged.push(buffer);
        buffer = null;
      }

      merged.push({
        author: "user",
        text: m.content,
        time: new Date(Number(m.created_at) * 1000).toISOString(),
      });

      return;
    }

    if (m.type === "chart") {
      if (!buffer) {
        buffer = {
          author: "assistant",
          type: "answer",
          text: "",
          debug: "",
          charts: [],
          isComplete: true,
          time: new Date(Number(m.created_at) * 1000).toISOString(),
        };
      }

      buffer.charts.push({
        isFile: false,
        title: m.title || "Chart",
        image: m.data,
      });

      return;
    }

    if (!buffer) {
      buffer = {
        author: "assistant",
        type: "answer",
        text: "",
        debug: "",
        charts: [],
        isComplete: true,
        time: new Date(Number(m.created_at) * 1000).toISOString(),
      };
    }

    if (typeof m.content === "string" && m.content.includes("???")) {
      const [debugText, answerText] = m.content.split("???");

      if (debugText.trim()) buffer.debug += debugText.trim() + "\n\n";
      if (answerText.trim()) buffer.text += answerText.trim();
    } else if (typeof m.content === "string" && m.content.trim()) {
      buffer.text += m.content.trim() + " ";
    }

    if (Array.isArray(m.images)) {
      m.images.forEach((img) => {
        buffer.charts.push({
          isFile: false,
          title: img.title || "Image",
          image: img.data,
        });
      });
    }

    if (Array.isArray(m.files)) {
      m.files.forEach((f) => {
        const filename = f.filename?.split("/").pop() || "download.csv";
        const isCSV =
          filename.toLowerCase().endsWith(".csv") || f.format === "csv";

        if (isCSV) {
          buffer.charts.push({
            isFile: true,
            filename,
            format: "csv",
            data: f.data,
            image: null,
          });
        }
      });
    }
  });

  if (buffer) merged.push(buffer);

  return merged;
};
